/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_buf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dissolving solids changes the volume slightly. Adding water to the final mark after dissolving keeps the concentrations accurate.`)
};

const es_buf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disolver los sólidos cambia ligeramente el volumen. Añadir agua hasta la marca final después de disolver mantiene las concentraciones precisas.`)
};

const de_buf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Lösen von Feststoffen verändert das Volumen leicht. Wird nach dem Lösen bis zur Endmarkierung mit Wasser aufgefüllt, bleiben die Konzentrationen genau.`)
};

const nl_buf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het oplossen van vaste stoffen verandert het volume licht. Door na het oplossen water toe te voegen tot de eindmarkering blijven de concentraties nauwkeurig.`)
};

const fr_buf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La dissolution des solides modifie légèrement le volume. Ajouter de l'eau jusqu'au trait final après dissolution garantit des concentrations précises.`)
};

const it_buf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sciogliere i solidi cambia leggermente il volume. Aggiungere acqua fino al segno finale dopo la dissoluzione mantiene accurate le concentrazioni.`)
};

const pt_br2_buf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dissolver os sólidos altera ligeiramente o volume. Adicionar água até a marca final depois de dissolver mantém as concentrações precisas.`)
};

const pt_buf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dissolver sólidos altera ligeiramente o volume. Adicionar água até à marca final depois de dissolver mantém as concentrações corretas.`)
};

const ja_buf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`固形物を溶かすと量がわずかに変化するためです。溶解後に最終目盛りまで水を加えることで、正確な濃度を保てます。`)
};

const zh_buf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`溶解固体会使体积略有变化。溶解后加水定容至刻度可保证浓度准确。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const buf_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.buf_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("buf_faq_a2", locale)
	if (locale === "en") return en_buf_faq_a2(inputs)
	if (locale === "es") return es_buf_faq_a2(inputs)
	if (locale === "de") return de_buf_faq_a2(inputs)
	if (locale === "nl") return nl_buf_faq_a2(inputs)
	if (locale === "fr") return fr_buf_faq_a2(inputs)
	if (locale === "it") return it_buf_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_buf_faq_a2(inputs)
	if (locale === "pt") return pt_buf_faq_a2(inputs)
	if (locale === "ja") return ja_buf_faq_a2(inputs)
	return zh_buf_faq_a2(inputs)
};